import { useTranslation } from "react-i18next";
import { Flame, ThumbsUp, Minus, BatteryLow, BatteryWarning, Icon as IconCmp } from "@phosphor-icons/react";

export type FeelKey = "excellent" | "good" | "ok" | "tired" | "terrible";

const MAP: Record<FeelKey, { icon: IconCmp; cls: string; i18nKey: string }> = {
  excellent: { icon: Flame,          cls: "text-accent",      i18nKey: "wellness:feel.excellent" },
  good:      { icon: ThumbsUp,       cls: "text-ok", i18nKey: "wellness:feel.good" },
  ok:        { icon: Minus,          cls: "text-fg-muted",    i18nKey: "wellness:feel.ok" },
  tired:     { icon: BatteryLow,     cls: "text-warn",   i18nKey: "wellness:feel.tired" },
  terrible:  { icon: BatteryWarning, cls: "text-bad",    i18nKey: "wellness:feel.terrible" },
};

export function FeelIcon({
  feel,
  size = 14,
  withLabel = false,
  className = "",
}: {
  feel: string | null | undefined;
  size?: number;
  withLabel?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!feel) return null;
  const m = MAP[feel as FeelKey];
  if (!m) return null;
  const Icon = m.icon;
  const label = t(m.i18nKey);
  return (
    <span className={`inline-flex items-center gap-1 ${m.cls} ${className}`} title={label}>
      <Icon size={size} strokeWidth={2} />
      {withLabel && <span className="text-xs">{label}</span>}
    </span>
  );
}

export const FEEL_OPTIONS: { value: FeelKey; i18nKey: string; icon: IconCmp; cls: string }[] = [
  { value: "excellent", i18nKey: "wellness:feel.excellent", icon: Flame,          cls: "text-accent" },
  { value: "good",      i18nKey: "wellness:feel.good",      icon: ThumbsUp,       cls: "text-ok" },
  { value: "ok",        i18nKey: "wellness:feel.ok",        icon: Minus,          cls: "text-fg-muted" },
  { value: "tired",     i18nKey: "wellness:feel.tired",     icon: BatteryLow,     cls: "text-warn" },
  { value: "terrible",  i18nKey: "wellness:feel.terrible",  icon: BatteryWarning, cls: "text-bad" },
];
